import { render, staticRenderFns } from "./CreatePin.vue?vue&type=template&id=96f79f8a&scoped=true&"
import script from "./CreatePin.vue?vue&type=script&lang=js&"
export * from "./CreatePin.vue?vue&type=script&lang=js&"
import style0 from "./CreatePin.vue?vue&type=style&index=0&id=96f79f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f79f8a",
  null
  
)

export default component.exports